import { Cake } from "lucide-react";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";

export default function AvisoCumpleanosDialog({ aviso, onCerrar }) {
  if (!aviso) return null;

  return (
    <AlertDialog open={!!aviso} onOpenChange={(open) => !open && onCerrar?.()}>
      <AlertDialogContent className="max-w-md border-pink-200 bg-gradient-to-b from-pink-50/90 to-white">
        <AlertDialogHeader>
          <div className="mx-auto mb-2 flex h-14 w-14 items-center justify-center rounded-2xl bg-gradient-to-br from-pink-400 to-violet-500 text-white shadow-md">
            <Cake className="h-7 w-7" strokeWidth={1.5} />
          </div>
          <AlertDialogTitle className="text-center text-xl">
            {aviso.titulo || "¡Feliz cumpleaños!"}
          </AlertDialogTitle>
          <AlertDialogDescription className="text-center text-base leading-relaxed text-zinc-700">
            {aviso.mensaje}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter className="sm:justify-center">
          <AlertDialogAction
            className="rounded-lg bg-gradient-to-r from-pink-500 to-violet-600 hover:from-pink-600 hover:to-violet-700"
            onClick={() => onCerrar?.()}
          >
            ¡Gracias!
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
